import React, { useEffect, useState, lazy, Suspense } from 'react';
import { Card, Row, Col, Statistic, Spin, Empty, Button, Skeleton } from 'antd';
import { CiDeliveryTruck, CiFileOn } from "react-icons/ci";
import { MdOutlineGroups } from "react-icons/md";
import dashboardService from '../../../services/dashbord-service';
import { checkPermission } from '../../../utils/permissions';
import { changeDocumentTitle } from '../../../utils/title';
import { CiCirclePlus } from "react-icons/ci";
import { MdOutlinePersonAdd } from "react-icons/md";
import { LuReceiptPoundSterling } from "react-icons/lu";
import { AiOutlineSchedule } from "react-icons/ai";
import { FaRegFileAlt } from "react-icons/fa";
import { FaRegFileLines } from "react-icons/fa6";
import { Link } from 'react-router-dom';
import ScheduleForm from '../schedule/ScheduleForm';
import Vechical from '../vehicles';
import VehicleYard from './VehicleYard';
import { IoMdFlash } from "react-icons/io";
import RecentVehicle from './RecentVehicle';

// Lazy-loaded components
const BookingNumberDashboard = lazy(() => import('./BookingNumber'));
const TableContainer = lazy(() => import('./TableContainer'));
const MissingContainer = lazy(() => import('./MissingContainer'));
// const VehicleYard = lazy(() => import('./VehicleYard'));
const NoTitleTable = lazy(() => import('./NoTitleTable'));
const InvoiceDue = lazy(() => import('./InvoiceDue'));
const InvoiceChart = lazy(() => import('./InvoiceChart'));
const InvoicesOverdue = lazy(() => import('./InvoicesOverdue'));
const CustomerOverdue = lazy(() => import('./CustomerOverdue'));
const CustomerDueSummary = lazy(() => import('./CustomerDueSummary'));

export default function Dashboard() {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({});
  const [modalVisible, setModalVisible] = useState(false)
  const [refresh, setRefresh] = useState(true);

  const [customerData, setCustomerData] = useState([])
  const [vehicleSummary, setVehicleSummary] = useState([])
  const [savePlanSummary, setSavePlanSummary] = useState([])

  useEffect(() => {
    changeDocumentTitle("Dashboard");
  }, []);

  const loadDashboard = async () => {
    setLoading(true);
    const { success, data } = await dashboardService.fetchDashbord();
    setCustomerData(data.customers_summary)
    setVehicleSummary(data.vehicles_summary)
    setSavePlanSummary(data.save_loadplan_summary)
    setLoading(false);
    if (success) {

      setData(data);
    }
  };

  useEffect(() => {
    loadDashboard();
    setRefresh(false)
  }, [refresh]);

  const cardData = [
    {
      title: "TOTAL CUSTOMERS",
      value: customerData.total,
      icon: MdOutlineGroups,
      stats: [
        { label: "Active", value: customerData.active, bg: "#F0FDF4", color: "#008236" },
        { label: "Inactive", value: customerData.inactive, bg: "#FEF2F2", color: "#C10007" },
        { label: "New (Month)", value: customerData.new_month, bg: "#EEF2FF", color: "#432DD7" }
      ]
    },
    {
      title: "Total Vehicles",
      value: vehicleSummary.total,
      icon: CiDeliveryTruck,
      stats: [
        { label: "Loaded", value: vehicleSummary.loaded, bg: "#F0FDF4", color: "#6A7282" },
        { label: "At Yard", value: vehicleSummary.at_yard, bg: "#EFF6FF", color: "#6A7282" },
        { label: "In Load Plan", value: vehicleSummary.in_load_plan, bg: "#FEFCE8", color: "#6A7282" },
        { label: "Returned", value: vehicleSummary.returned, bg: "#FEF2F2", color: "#6A7282" },
      ]
    },
    {
      title: "Total Saved Load Plans",
      value: savePlanSummary.total,
      icon: CiFileOn,
      stats: [
        { label: "Saved", value: savePlanSummary.saved, bg: "#F3F4F6", color: "#6A7282" },
        { label: "Loaded", value: savePlanSummary.loaded, bg: "#F0FDF4", color: "#6A7282" },
        { label: "Client Request", value: savePlanSummary.loaded, bg: "#EFF6FF", color: "#6A7282" },
      ]
    },
  ];
  return (
    <div className="dashboard-container">
      <div className='w-full border px-4 py-3 rounded-lg border-[#FFC9C9] mb-6 flex flex-col gap-2 bg-white '>
        <IoMdFlash className='!text-lg' />

        <div className='flex justify-between w-full'>
          <Link to="/vehicle/add">
            <Button type='primary' icon={<CiCirclePlus className='!text-base' />}>Add Vehicle</Button>
          </Link>
          <Link to="/operations/customer/form">
            <Button type='primary' icon={<MdOutlinePersonAdd className='!text-base' />}>Add Customer</Button>
          </Link>
          <Link to="/operations/quotation/form/">
            <Button type='primary' icon={<FaRegFileAlt className='!text-base' />}>Add Quotation</Button>
          </Link>

          <Button type='primary' icon={<AiOutlineSchedule className='!text-base' />} onClick={() => setModalVisible(true)}>Booking Schedule</Button>

          <Link to="/invoice/add">
            <Button type='primary' icon={<FaRegFileLines className='!text-base' />}>Add Invoice</Button>
          </Link>
          <Link to="/accounts/receipt-collects/add">
            <Button type='primary' icon={<LuReceiptPoundSterling className='!text-base' />}>Add Receipt</Button>
          </Link>
        </div>

      </div>

      {/* Top Cards Section */}
      <div className="w-full flex gap-3">
        {cardData.map((card, index) => {
          const Icon = card.icon;

          return (
            <Card key={index} className="!w-full !rounded-xl border-[#CCCCCC]">
              {
                loading ? (
                  <Skeleton active paragraph={{ rows: 3 }} />) : (
                  <div loading={loading}>
                    <div className="flex justify-between mb-5">
                      <Statistic title={card.title} value={card.value} />
                      <Icon className="bg-primary" style={iconStyle} />
                    </div>

                    <div className="flex gap-3">
                      {card.stats.map((stat, i) => (
                        <div
                          key={i}
                          className="flex flex-col p-3 w-full rounded-lg"
                          style={{ background: stat.bg }}
                        >
                          <span className="text-[11px] text-[#6A7282] py-1">
                            {stat.label}
                          </span>
                          <span
                            className="text-base font-semibold"
                            style={{ color: stat.color }}
                          >
                            {stat.value}
                          </span>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
            </Card>
          );
        })}
      </div>
      <br />
      {/* Tables Section */}
      {
        checkPermission("VIEW_DASHBOARD") ?
          <>
            {/* <Row gutter={[24, 24]}>
            <Col xs={24} lg={12}>
              <Suspense fallback={<Spin />}>
                <BookingNumberDashboard bookingNo={data.booking_numbers} loading={loading} />
              </Suspense>
            </Col>
            <Col xs={24} lg={12}>
              <Suspense fallback={<Spin />}>
                <TableContainer containerNo={data.container_numbers} />
              </Suspense>
            </Col>
          </Row> */}

            {/* Components Section */}
            <div className="flex flex-col gap-6 mt-5">
              <VehicleYard />
            </div>
            <div className="flex flex-col gap-6 mt-5">
              <Suspense fallback={<Spin />}>
                {/* <VehicleYard /> */}
                <RecentVehicle  />
                {/* <NoTitleTable /> */}
                {/* <MissingContainer saveload={data.saved_loading} /> */}
              </Suspense>
            </div>

            {/* Invoice Section */}
            {/* <Row gutter={[24, 24]} className="mt-8">
            <Col xs={24} lg={12}>
              <Suspense fallback={<Spin />}>
                <InvoiceDue />
              </Suspense>
            </Col>
            <Col xs={24} lg={12}>
              <Suspense fallback={<Spin />}>
                <InvoiceChart chart={data.invoices} pieChart={data.pieChart} />
              </Suspense>
            </Col>
          </Row> */}

            {/* Overdue Section */}
            {/* <div className="mt-10">
            <Suspense fallback={<Spin />}>
              <InvoicesOverdue />
            </Suspense>
          </div> */}
            {/* <Row gutter={[24, 24]} className="mt-8">
            <Col xs={24} lg={12}>
              <Suspense fallback={<Spin />}>
                <CustomerOverdue />
              </Suspense>
            </Col>
            <Col xs={24} lg={12}>
              <Suspense fallback={<Spin />}>
                <CustomerDueSummary />
              </Suspense>
            </Col>
          </Row> */}
          </> : <></>
        // <Row>
        //   <Col span={9} style={{ textAlign: "right", alignContent:'center' }}>
        //     <span style={{ fontSize: "44px", color: "red", fontWeight: "bold" }}>!</span>
        //   </Col>
        //   <Col >
        //     <Empty description='No Access'>
        //     </Empty>
        //   </Col>
        // </Row>
      }
      <ScheduleForm
        visible={modalVisible}
        onClose={() => setModalVisible(false)}
        setRefresh={setRefresh}
      />
    </div >
  );
}

const iconStyle = {
  fontSize: '40px',
  color: 'white',
  padding: '6px',
  borderRadius: '10px',
};
